import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class GameCMainCharacter extends PIXI.Container {

  constructor(game) {
    super();

    this.spritesheet = game.assets["main_character_sheet"];

    this.idleTexture = [PIXI.Texture.from("main-character-rest")];

    this.animationTextures = [];

    for (let i = 0; i < this.spritesheet.data.animations["main-character-anim"].length; i++) {

      const textureName = this.spritesheet.data.animations["main-character-anim"][i];
      const texture = PIXI.Texture.from(textureName);
      const time = this.spritesheet.data.frames[textureName].duration;

      this.animationTextures.push({texture, time});
    }

    this.sprite = new PIXI.AnimatedSprite(this.idleTexture);
    this.sprite.loop = true;

    this.addChild(this.sprite);

    this.sprite.onComplete = null;
    this.sprite.onLoop = null;
  }

  startWalking() {
    this.sprite.textures = this.animationTextures;

    this.sprite.gotoAndPlay(0);
  }

  stopWalking() {
    this.sprite.gotoAndStop(0);

    this.sprite.textures = this.idleTexture;
  }
}
